module.exports = __webpack_public_path__ + "images/emoji/minibus.6cb0d6fe3f8520d8f7a6.png";